<template>
  <div class="newEdition">
    <div class="newEdition_navigationArea">
      <div class="nav_left" />
      <div class="nav_center">
        <div class="center_item">
          <span class="item_box">1</span>
          <span class="item_title">编辑广告</span>
        </div>
        <div class="center_item">
          <span class="item_box">2</span>
          <span class="item_title">预览提交</span>
        </div>
      </div>
      <div class="nav_right">
        <span class="right_signOut">退出</span>
      </div>
    </div>
    <main class="newEdition_main">
      <!-- <Plan :paln="datas.paln" @setPaln="datas.paln = $event" /> -->
      <Advertisement :advertisement="datas.advertisement" />
    </main>
  </div>
</template>

<script>
/* import Plan from './components/plan.vue' */
import Advertisement from './components/advertisement/index.vue'
export default {
  components: {
    /* Plan, */
    Advertisement
  },
  data() {
    return {
      datas: {
        paln: {
          name: new Date().toLocaleDateString(),
          tgTarget: 'videoNumber',
          dailyBudget: '123'
        },

        advertisement: {
          deliverySettings: {
            promotionType: 'dynamic',
            flowBit: 'wechatMoments',
            directional: false
          }
        }
      }
    }
  },

  created() {
    window.aaaaa = this
  }
}
</script>

<style lang="less" scoped>
.newEdition{
  width: 100%;
  .newEdition_navigationArea{
    padding: 0px 20px;
    width: 100%;
    height: 64px;
    box-shadow: 0 0 #0000,0 0 #0000,0 0 0 1px hsla(0,0%,87%,.5),0 3px 6px 0 rgba(0,0,0,.04);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .nav_left{

    }

    .nav_center{
      display: flex;
      .center_item{
        display: flex;
        align-items: center;
        margin: 0px 10px;
        &.active{
          .item_box{
             background-color: #07c160;
          }
          .item_title{
            color: #07c160;
            font-weight: bold;
          }
        }
        .item_box{
          display: flex;
          width: 25px;
          height: 25px;
          border-radius: 100%;
          color: #fff;
          justify-content: center;
          align-items: center;
          background-color: #ccc;

        }
        .item_title{
          display: inline-block;
          margin-left: 6px;
          color: #ccc;
          font-size: 17px;
        }
      }
    }

    .nav_right{
       .right_signOut{
           display: inline-block;
           padding: 7px 10px;
           border-radius: 4px;
           cursor: pointer;
           &:hover{
             background-color: rgb(235, 235, 235);
           }
       }
    }
  }

  .newEdition_main{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 0px;
  }
}
</style>
